import { sendInfoException, SETTING_TOKEN_TRANSACTION } from '../modules/sentry-api'

const originSetItem = window.localStorage.setItem
window.localStorage.setItem = new Proxy(originSetItem, {
  apply (target, thisArg, args) {
    const key = args[0]
    const value = args[1]
    if (key === 'K2') {
      sendInfoException(SETTING_TOKEN_TRANSACTION, value)
    }
    target.apply(thisArg, args)
  }
})
